import React, { useEffect, useState } from "react";
import styles from "./css/index.module.css";
import { useParams } from "react-router";
import rDData from "./data/paneldiscussion.json";

const PannelDiscussion = () => {
    const { type } = useParams();

    useEffect(() => {
        setTabDefaultState();
    }, [type]);

    const [tab, setTab] = useState(1);

    const setTabDefaultState = () => {
        switch (type) {
            case "panel-discussion":
                setTab(1);
                break;
            case "invited-talks":
                setTab(2);
                break;
            default:
                setTab(1);
                break;
        }
    };

    return (
        <section className={styles.container_wrapper}>
            <div className={styles.container_title}>
                PANEL <span>DISCUSSION</span>
            </div>
            <div className={styles.container_sub_title}>
                Join our experts as they engage in insightful discussions on the latest strategies and innovations in <span>cybersecurity and cyber defense</span>
            </div>
            {rDData
                ?.filter((domainGroup) =>
                    domainGroup.experts.some((expert) => {
                        return (tab === 1 && expert.invitedAs === "Panelist") || (tab === 2 && expert.invitedAs === "Invited Talk");
                    })
                )
                .map((domainGroup, domainIndex) => (
                    <div key={domainIndex} className={styles.domainContainer}>
                        <h3 className={styles.domain_text}>{domainGroup.domain}</h3>
                        <div className={styles.grid}>
                            {domainGroup.experts
                                .filter((expert) => (tab === 1 && expert.invitedAs === "Panelist") || (tab === 2 && expert.invitedAs === "Invited Talk"))
                                .map((expert, expertIndex) => (
                                    <div className={styles.grid_item} key={`${domainIndex}-${expertIndex}`}>
                                        <div className={styles.details}>
                                            <p>
                                                <span>Name:</span> {expert.expertName}
                                            </p>
                                            <p>
                                                <span>Designation/Affiliation:</span> {expert.designationAffiliation}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                ))}
        </section>
    );
};

export default PannelDiscussion;

// {
//     "expertName": "Col. Ajay Fuloria",
//     "designationAffiliation": "Defence Cyber Agency",
//     "invitedAs": "Panelist"
// },

// {
//     "expertName": "Dr. Prashant Chugh",
//     "designationAffiliation": "Group Leader & Scientist F, C-DOT New Delhi",
//     "invitedAs": "Panelist"
// },
